import { Button } from '@mui/material';
import { SwipableDialog } from '@tix-ticketing/ui-components';
import { TicketsAlertIcon } from '@tix-ticketing/ui-icons/feature';
import { FormattedMessage, useIntl } from 'react-intl';

/**
 * Confirms dropping a ticket change, either because the buyer removed one of
 * the returned tickets (a change takes exactly as many tickets as it hands
 * back, so it cannot go on with fewer) or because they asked to cancel it
 * directly from the cart.
 */
export const ExchangeCancelDialog = ({
  open,
  onClose,
  onCancelExchange,
  variant = 'remove'
}: {
  open: boolean;
  onClose: () => void;
  onCancelExchange: () => void;
  variant?: 'remove' | 'direct';
}) => {
  const intl = useIntl();
  const headerText = variant === 'remove' ? intl.formatMessage({
    id: "changeTickets.cancelPrompt.removeTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Remove tickets and cancel the change?"
    }]
  }) : intl.formatMessage({
    id: "changeTickets.cancelPrompt.directTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Cancel your ticket change?"
    }]
  });
  const subtitleText = variant === 'remove' ? intl.formatMessage({
    id: "changeTickets.cancelPrompt.removeDescription",
    defaultMessage: [{
      "type": 0,
      "value": "Your change takes exactly as many tickets as you hand back, so removing these tickets cancels it. Your original tickets stay as they are and nothing is charged."
    }]
  }) : intl.formatMessage({
    id: "changeTickets.cancelPrompt.directDescription",
    defaultMessage: [{
      "type": 0,
      "value": "Cancelling now drops your ticket change. Your original tickets stay as they are and nothing is charged."
    }]
  });
  return <SwipableDialog open={open} onClose={onClose} maxWidth="sm" headerIcon={<TicketsAlertIcon />} headerText={headerText} subtitleText={subtitleText} primaryActionButton={<Button data-testid="exchange-cancel-confirm-button" variant="contained" color="primary" size="large" fullWidth onClick={onCancelExchange}>
          <FormattedMessage id="changeTickets.cancelPrompt.confirm" defaultMessage={[{
      "type": 0,
      "value": "Cancel the change"
    }]} />
        </Button>} secondaryActionButton={<Button data-testid="exchange-cancel-keep-button" variant="contained" color="monochrome" size="large" fullWidth onClick={onClose}>
          <FormattedMessage id="changeTickets.cancelPrompt.keep" defaultMessage={[{
      "type": 0,
      "value": "Keep the change"
    }]} />
        </Button>} />;
};